var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedalBold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25C5.37665 1.25 3.25 3.37665 3.25 6C3.25 8.62335 5.37665 10.75 8 10.75C10.6234 10.75 12.75 8.62335 12.75 6C12.75 3.37665 10.6234 1.25 8 1.25Z",
    stroke: "#414141",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.27222C7.58579 5.27222 7.25 5.608 7.25 6.02222C7.25 6.43643 7.58579 6.77222 8 6.77222C8.41421 6.77222 8.75 6.43643 8.75 6.02222C8.75 5.608 8.41421 5.27222 8 5.27222Z",
    stroke: "#414141",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.94519L5 14.8859L8 13.6108L11 14.8859L11 9.94519",
    stroke: "#414141",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedalBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MedalBold.f3d10a8e99ac0349c8a283f0bd35636e.svg";